module.exports = __webpack_public_path__ + "voicecall_ico@2x.6cced0f5506d1c0a2ee3b9388e64753f.png";